import { useCallback } from 'react';
import * as pas from 'js/hooks/auth/pas';
import { useTranslations } from 'js/hooks/i18n';
import { useGetErrorMessage, useGetErrorResponseMessage } from 'js/hooks/server';

export const useValidateTwoFactorToken = ({ onSuccess, onClose, setError }) => {
    const getErrorResponseMessage = useGetErrorResponseMessage();
    const translate = useTranslations('playtech.mobile.system.2fa.');
    const getErrorMessage = useGetErrorMessage({ translate });

    return useCallback(async ({ token, twoFactorMessageCode }) => {
        setError();

        try {
            await pas.validateTwoFactorToken(token, Number(twoFactorMessageCode));
        } catch (error) {
            const errorMsg = getErrorMessage(error);

            setError(errorMsg);

            return errorMsg;
        }

        try {
            await onSuccess();

            onClose();
        } catch (error) {
            const errorMessage = getErrorResponseMessage(error);

            setError(errorMessage);

            return errorMessage;
        }
    }, [onSuccess, onClose, setError, getErrorResponseMessage, getErrorMessage]);
};
